// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__lsNUe","meals-appear":"AvailableMeals_meals-appear__unXWJ"};